import React from 'react';
import ReactTable from 'react-table';
import firebase from 'firebase/app';
import 'firebase/database';
import FontAwesome from 'react-fontawesome';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import RoleOptions from './role-options';

/** @class PendingUserList
  * A component for displaying pending users (users who have not yet logged in)
  * of the Vexpo Admin Platform.
  */
export default class PendingUserList extends ReactFireComponent {
  /** @constructor
    * Constructs a new PendingUserList
    */
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      pendingUser: {
        id: firebase.database().ref('/pendingUsers/').push().key,
        name: '',
        email: '',
        role: 'Unassigned'
      }
    }
    this.handleRemove = this.handleRemove.bind(this);
  }
  /** @method componentWillMount
    * Binds the component to the list of pending users
    * in the firebase database.
    */
  componentWillMount(){
    this.bindAsArray(`/pendingUsers`, 'users');
  }
  /** @method componentWillUnmount
    * Unbinds the component from the firebase database.
    */
  componentWillUnmount() {
    this.unbind('users');
  }
  /** @method handleEmail
    * Sends a new login link email to a user
    * @param {string} id - the user to send the link to.
    */
  handleEmail(id) {
    const user = this.state.users.find(user => {
      return user.id === id;
    });
    if(user && user.email) {
      const actionCodeSettings = {
        url: 'https://admin.vexposhows.com/',
        handleCodeInApp: true
      };
      firebase.auth().sendSignInLinkToEmail(user.email, actionCodeSettings)
      .then(() => window.alert(`Login link email sent to ${user.name} at ${user.email}`))
      .catch((error) => {
        window.alert(`Error sending login link email to ${user.name} at ${user.email}: ${error.code}`);
        console.error(error);
      });
    }
  }
  /** @method handleRemove
    * Handles the removal of a pending user.
    * @param {string} id - the id of the pending user
    */
  handleRemove(id) {
    if(window.confirm("Are you sure?  This will permanently remove this pending user from the Vexpo Admin Platform.")){
      firebase.database().ref(`/pendingUsers/${id}`).set(null);
    }
  }
  /** @method render
    * Renders the component
    */
  render() {
    const columns = [
      {Header: 'Name', accessor: 'name'},
      {Header: 'Role', accessor: 'role',
        filterMethod: (filter, row) => {
          if(filter.value === "all") return true;
          else return filter.value === (row["role"])
        },
        Filter: ({filter, onChange}) => (
          <select
            onChange={event => onChange(event.target.value)}
            style={{width: "100%"}}
            value={filter ? filter.value : "All"}
          >
            <option value="all">All</option>
            <RoleOptions/>
          </select>
        )
      },
      {Header: 'Email', accessor: 'email', Cell: row => (
        <a href={`mailto://${row.value}`}>{row.value}</a>
      )},
      {Header: '', accessor: 'id', Cell: row => (
        <div style={{textAlign:'right'}}>
        <FontAwesome name="envelope"
          style={{color:'green', cursor: 'pointer'}}
          onClick={() => this.handleEmail(row.value)}/>
        <FontAwesome name="times"
            style={{color:'red', cursor: 'pointer'}}
            onClick={() => this.handleRemove(row.value)}/>
        </div>
      ),
      filterable: false}
    ]
    const style = {
      width: '100%',
      maxWidth: '600px'
    }
    return (
      <div>
        <h3 style={{marginBottom: 0}}>Pending Users</h3>
        <ReactTable
          className="-striped"
          data={this.state.users}
          columns={columns}
          defaultPageSize={15}
          style={style}
          filterable
          />
      </div>
    )
  }
}

PendingUserList.propTypes = {}



// WEBPACK FOOTER //
// ./src/user-list/pending-user-list.js